import "./../css/style.scss";
import $ from 'jquery';
/*global vars*/
/*eslint no-undef: "error"*/

$(function () {
    updateHeaderHeight();

    let resizeTimeout;
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateHeaderHeight, 100); // 100ms delay
    });

    if ($(".ow-popup--nujna").length) {
        const currCookie = getCookie("ow_popup_nujna");
        const exdate = new Date();
        exdate.setDate(exdate.getDate() + 1);

        const c_value_nujna = "1; expires=" + exdate.toUTCString() + "; path=/; SameSite=Strict; Secure; ";

        if (currCookie == null || currCookie === "0") {
            $(".ow-popup--nujna").addClass("active");
        }

        $(".ow-popup--nujna .ow-popup__close").on("click", function () {
            document.cookie = "ow_popup_nujna =" + c_value_nujna;
            $(".ow-popup--nujna").removeClass("active");
        });
        $(".ow-popup--nujna .wp-block-button").on("click", function () {
            document.cookie = "ow_popup_nujna =" + c_value_nujna;
            $(".ow-popup--nujna").removeClass("active");
        });
    }
});

$('.widgettitle').on("click", function () {
    if ($(window).width() < 768) {
        if ($(this).hasClass("active")) {
            $('.widgettitle').removeClass("active");
            $(this).next().slideUp('fast').removeClass("active");
        } else {
            $('.widgettitle').removeClass("active");
            $(this).addClass("active");
            $(this).next().slideToggle('fast').addClass("active");
            //Hide the other panels
            $(".widgettitle + div").not($(this).next()).slideUp('fast').removeClass("active");
        }
    }
});


$(".filter-kategorije").on('change', 'input', function () {
    let slugs = get_filters_archive();
    const urlParams = new URLSearchParams(window.location.search);
    if (slugs.length > 0) {
        urlParams.set('kategorije', slugs.join(','));
    } else {
        urlParams.delete('kategorije');
    }
    const wrap = $(this).closest(".novice-arhiv").find(".novice-box-ajax");
    urlParams.delete('pa');
    if (urlParams.toString()) {
        window.history.replaceState(null, null, "?" + urlParams.toString());
    } else {
        window.history.replaceState(null, null, window.location.pathname);
    }
    ajax_novice_box(wrap, slugs);
});

$(".novice-arhiv").on('click', '.novice-box__pagination .page-numbers:not(.current):not(.dots)', function (event) {
    event.preventDefault();
    const wrap = $(this).closest(".novice-box-ajax");
    const box = $(this).closest(".novice-arhiv");
    let slugs = get_filters_archive();
    let page = $(this).data("page");
    $('html, body').animate({
        scrollTop: box.offset().top - 150
    }, 500);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('pa', page);
    window.history.replaceState(null, null, "?" + urlParams.toString());
    ajax_novice_box(wrap, slugs, page);
});

function get_filters_archive() {
    let slugs = [];
    $(".filter-kategorije").find("input[type='checkbox']:checked").each(function () {
        slugs.push($(this).attr("value"));
    })

    return slugs;
}

function ajax_novice_box(wrap, terms, page = 0) {
    $('.novice-box-ajax').addClass("loading");
    console.log(terms);
    $.ajax({
        type: "post",
        url: vars.ajaxurl,
        data: {
            action: "returnNoviceBox",
            terms: terms,
            page: page,
            postCount: wrap.attr("data-post-count"),
            loadMore: wrap.attr("data-load-more"),
            nonceOW: vars.nonce
        },
        success: function (data) {
            wrap.html(data);
            $('.novice-box-ajax').removeClass("loading");

        },
        error: function () {
            $(".novice-box-ajax").removeClass("loading");
            alert("error");
        }
    });
}

function updateHeaderHeight() {
    var headerHeight = $('#header').outerHeight();
    document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
}

function getCookie(c_name) {
    let c_value = document.cookie;
    let c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
        c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        let c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}

$.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
$.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
$.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
$.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};

document.addEventListener('DOMContentLoaded', function () {
    const levelTwoLinks = document.querySelectorAll('#menu-mobile .menu > li > .sub-menu > li > a');

    levelTwoLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const href = this.getAttribute('href');

            if (href && href !== '#') {
                e.stopPropagation();

                window.location.href = href;
            }
        });
    });
});

document.querySelectorAll('.menu-toggle').forEach(button => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        const parentItem = button.closest('.menu-side__menu-item');
        parentItem.classList.toggle('is-open');
    });
});

